const uri = "/Voting";

export default uri;
